import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Login from '../login/login';
import loginService from '../../service/login';

export default function requireAuths(Component) {
  const Authenticate = (props) => {
    const history = useHistory();

    const [state, setState] = useState({
      userToken: false,
      tokenVarified: false,
      loading: true,
    });

    const checkRequireAuth = () => {
      const token = loginService.getToken();

      if (token) {
        setState((st) => ({
          ...st,
          userToken: token,
        }));

        history.push(props.location.pathname);
      } else {
        setState((st) => ({
          ...st,
          loading: false,
          tokenVarified: false,
          userToken: false,
        }));

        props.history.push('/');
      }
    };

    useEffect(() => {
      checkRequireAuth();
    }, []);

    return (
      <>
        {state.userToken ? (
          <Component {...props} />
        ) : (
          <div className="scroll flex layout-column">
            {props.location.pathname === '/' ? (
              <Login history={props.history} />
            ) : (
              <Login />
            )}
          </div>
        )}
      </>
    );
  };

  return Authenticate;
}
